
import { storage } from '../lib/storage';
import { VIPConfig, VIPTierLevel, Order, Store } from '../types';

export const DEFAULT_VIP_CONFIGS: VIPConfig[] = [
  { level: 'SILVER', spendThreshold: 500, discountPercentage: 5, color: '#94a3b8', label: 'Silver Member' },
  { level: 'GOLD', spendThreshold: 2000, discountPercentage: 10, color: '#fbbf24', label: 'Gold Elite' },
  { level: 'PLATINUM', spendThreshold: 5000, discountPercentage: 15, color: '#8b5cf6', label: 'Platinum Legend' },
];

export const vipService = {
  getStoreVIPConfigs: (storeId: string): VIPConfig[] => {
    const store = storage.getStoreConfig(storeId);
    return store.vipConfigs || DEFAULT_VIP_CONFIGS;
  },

  updateVIPConfigs: (storeId: string, configs: VIPConfig[]) => {
    const store = storage.getStoreConfig(storeId);
    const updated = { ...store, vipConfigs: configs };
    storage.saveStoreConfig(updated);
    return updated;
  },

  getCustomerSpend: (storeId: string, userId: string): number => {
    const orders = storage.getOrders().filter(o => o.storeId === storeId && o.userId === userId && o.status !== 'CANCELLED');
    return orders.reduce((sum, o) => sum + o.total, 0);
  },

  getCurrentTier: (storeId: string, userId: string): VIPConfig | null => {
    const totalSpend = vipService.getCustomerSpend(storeId, userId);
    const configs = vipService.getStoreVIPConfigs(storeId).sort((a,b) => b.spendThreshold - a.spendThreshold);
    
    for (const config of configs) {
      if (totalSpend >= config.spendThreshold) return config;
    }
    return null;
  },

  getNextTierInfo: (storeId: string, userId: string) => {
    const totalSpend = vipService.getCustomerSpend(storeId, userId);
    const configs = vipService.getStoreVIPConfigs(storeId).sort((a,b) => a.spendThreshold - b.spendThreshold);
    
    const nextTier = configs.find(c => c.spendThreshold > totalSpend);
    if (!nextTier) return null;

    return {
      tier: nextTier,
      remaining: nextTier.spendThreshold - totalSpend,
      progress: (totalSpend / nextTier.spendThreshold) * 100
    };
  }
};
